<div class="mt-3">
  <!-- <h5 class="ml-3 p-text-bold text-primary">Visit details </h5> -->
  <h5 class="ml-3 p-text-bold heading">Visit Details </h5>
  <!-- <small class="pl-3 icn" (click)="backToList()">
    << Back to list </small> -->

    <button class="back-button pl-3 pr-3 back-btn-white-bg" (click)="backToList()"><i class="ml-0 fa fa-chevron-circle-left" aria-hidden="true"></i>Back</button>
</div>
<div class="m-3">
  <mat-horizontal-stepper #stepper labelPosition="bottom">
    <mat-step>
      <ng-template matStepLabel>Visit Details</ng-template>
      <mat-divider></mat-divider>
       <h6 class="ml-3 mt-3 p-text-bold heading">Visit Details </h6> 
      <form [formGroup]="fdnsVisitForm" class="p-3">
        <div class="p-fluid p-formgrid p-grid pt-2">

          <div class="p-col-4">
            <label for="dateofvisit" id="dateofvisit" class="required">Date Of Visit</label>
            <p-calendar formControlName="visitDate" appendTo="dateofvisit" [showIcon]="true" dateFormat="mm-dd-yy"
              inputId="dateofvisit" (onSelect)="handleDateValueChanges()"></p-calendar>

            <span class="invalid-message"
              *ngIf="fdnsVisitForm.get('visitDate').touched && fdnsVisitForm.get('visitDate').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="p-col-4">
            <label for="companyname" class="required">Visit Company Name</label>
            <p-dropdown inputId="companyname" [options]="petitionerCompanyList" formControlName="companyId"
              name="companyId" optionLabel="companyName" optionValue="id" placeholder="Select a Company"
              (onChange)="onChangeCompanyName()">
            </p-dropdown>


            <span class="invalid-message"
              *ngIf="fdnsVisitForm.get('companyId').touched && fdnsVisitForm.get('companyId').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="p-col-4">
            <label for="dateofvisit" class="required">Visit Location</label>
            <p-dropdown inputId="visitLocationCode" [options]="visitLocations" formControlName="visitLocationCode"
              name="visitLocationCode" optionLabel="name" optionValue="code" placeholder="Select a Location">
            </p-dropdown>
            <!-- <input type="text" class="" name="visitLocationAddress" formControlName="visitLocationAddress"> -->


            <span class="invalid-message"
              *ngIf="fdnsVisitForm.get('visitLocationCode').touched && fdnsVisitForm.get('visitLocationCode').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>

        </div>
        <div class="p-fluid p-formgrid p-grid pt-2">
          <div class="p-col-4">
            <label for="visitOfficer" class="required">Visit Officer</label>
            <input type="text" class="" name="visitOfficerName" formControlName="visitOfficerName">

            <span class="invalid-message"
              *ngIf="fdnsVisitForm.get('visitOfficerName').touched && fdnsVisitForm.get('visitOfficerName').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="p-col-4">
            <label for="modeOfVisit" class="required">Mode of Visit</label>
            <p-dropdown inputId="modeOfVisit" [options]="modeOfVisitTypes" formControlName="modeOfVisitCode"
              name="modeOfVisitCode" optionLabel="name" optionValue="code" placeholder="Select a Mode of Visit">
            </p-dropdown>


            <span class="invalid-message"
              *ngIf="fdnsVisitForm.get('modeOfVisitCode').touched && fdnsVisitForm.get('modeOfVisitCode').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>

        </div>
        <div class="p-fluid p-formgrid p-grid pt-2 mt-3">
          <div class="p-col-2 required">Visit Related To</div>
          <div class="p-col-4">
            <p-radioButton name="visitRelatedToCode" value="BEN" label="Beneficiary"
              formControlName="visitRelatedToCode" (onClick)="changeInVisitRelates()"></p-radioButton>
            <p-radioButton name="visitRelatedToCode" class="ml-2" value="PETNR" label="Petitioner"
              formControlName="visitRelatedToCode" (onClick)="changeInVisitRelates()"></p-radioButton>
            <p-radioButton name="visitRelatedToCode" class="ml-2" value="BOTH" label="Both"
              formControlName="visitRelatedToCode" (onClick)="changeInVisitRelates()"></p-radioButton>
          </div>

        </div>
        <div class="p-grid dashed-line p-my-4 mx-1"></div>
        <div *ngIf="showBeneficiaryDetailsSection">
          <h6 class="p-text-bold heading">Beneficiary Details </h6>
          <div class="p-fluid p-formgrid p-grid pt-2 mt-3">
            <div class="p-col-4">
              <label for="beneficiaryname" class="required">Beneficiary Name</label>
              <p-dropdown inputId="beneficiaryname" [options]="beneficiaryList" formControlName="beneficiaryId"
                name="beneficiaryId" optionLabel="beneficiaryName" optionValue="beneficiaryId"
                (onChange)="onChangeBeneficiary()" placeholder="Select a Beneficiary">
              </p-dropdown>
              <span class="invalid-message"
                *ngIf="fdnsVisitForm.get('beneficiaryId').touched && fdnsVisitForm.get('beneficiaryId').errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>
            <div class="p-col-4">
              <label for="visatype" class="required">Visa Type</label>
              <p-dropdown inputId="visatype" [options]="visaTypes" formControlName="visaTypeCode" optionLabel="name"
                name="visatype" optionValue="code" placeholder="Select Visa Type">
              </p-dropdown>
              <span class="invalid-message"
                *ngIf="fdnsVisitForm.get('visaTypeCode').touched && fdnsVisitForm.get('visaTypeCode').errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>

            <div class="p-col-4">
              <label for="petitiontype" class="required">Petition Type</label>
              <p-dropdown inputId="petitiontype" [options]="petitionTypes" formControlName="petitionTypeCode"
                name="pettype" optionLabel="name" optionValue="code" placeholder="Select Petition Type">
              </p-dropdown>
              <span class="invalid-message"
                *ngIf="fdnsVisitForm.get('petitionTypeCode').touched && fdnsVisitForm.get('petitionTypeCode').errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid pt-2">
            <div class="p-col-4">
              <label for="jobTitle" class="required">Job Title</label>
              <input type="text" class="" name="jobTitle" formControlName="jobTitle">

              <span class="invalid-message"
                *ngIf="fdnsVisitForm.get('jobTitle').touched && fdnsVisitForm.get('jobTitle').errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>
          </div>
          <div class="p-grid dashed-line p-my-4 mx-1"></div>
        </div>
        <div class="p-fluid p-formgrid p-grid pt-2 mt-3">
          <div class="p-col-4">
            <label for="visitOutcomeStatusCode" class="required">Visit Status</label>
            <p-dropdown inputId="visitOutcomeStatusCode" [options]="visitStatusList"
              formControlName="visitOutcomeStatusCode" name="visitOutcomeStatusCode" optionLabel="name"
              optionValue="code" placeholder="Select a Status">
            </p-dropdown>


            <span class="invalid-message"
              *ngIf="fdnsVisitForm.get('visitOutcomeStatusCode').touched && fdnsVisitForm.get('visitOutcomeStatusCode').errors?.required">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
          </div>
          <div class="p-col-8">
            <label for="visitOfficer">Visit Summary</label>
            <textarea [rows]="1" formControlName="visitSummary" pInputTextarea autoResize="autoResize"></textarea>


          </div>

        </div>





        <!-- <div class="p-grid dashed-line p-my-4 mx-5"></div> -->
        <div class="p-grid dashed-line p-my-4 mx-1"></div>
        <div class="p-fluid p-formgrid p-grid pt-2">
          <div class="p-col-9">
           
          </div>
          <!-- <div class="p-col-7"></div> -->
          <div class="p-col-3">
            
            <button class="btn btn-primary mt-0 float-right" matStepperNext [disabled]="!fdnsVisitId">Next</button>
            <button  type="submit" class="btn btn-primary mt-0 float-right mr-3" label="Save" [disabled]="!fdnsVisitForm.valid"
            (click)="saveFdnsVisit()">Save</button>
          </div>
          <!-- <div class="p-col-3">
          <button pButton type="button" class="p-button-secondary" label="Cancel" (click)="backToDashboard()"></button>
        </div> -->
        </div>



      </form>

    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Related Documents</ng-template>
      <mat-divider></mat-divider>


      <div class="formBox">
        <div class="row">

          <h6 class="mt-3 ml-3 p-text-bold heading">Upload the related documents for this visit</h6>
        </div>


        <div class="row">
          <div class="col-12">
            <app-prime-file-upload [fileConfigurations]="fileConfigurations" (fileUploadSuccess)="fileUploadSuccess()">
            </app-prime-file-upload>

            <!-- <app-file-upload style="width: 100%;" [configurations]="configurations"></app-file-upload> -->
          </div>

        </div>


        <hr />
        <div class="row">
          <div class="col-8">

            <!-- <button type="button" class="back-button" matStepperPrevious>
              Back
            </button> -->
            <button class="back-button pl-3 pr-3" 
            matStepperPrevious><i class="fa fa-chevron-circle-left" aria-hidden="true"></i>Back</button>

          </div>

        </div>

      </div>


    </mat-step>
  </mat-horizontal-stepper>
</div>
